const MAX_LENGTH = 2000;

export function normalizeMessageContent(raw: string): string {
  const normalizedBreaks = raw.replace(/\r\n/g, "\n").replace(/\n{3,}/g, "\n\n");
  return normalizedBreaks.trim();
}

export function validateMessageContent(raw: string): { content: string; errorKey?: string } {
  const content = normalizeMessageContent(raw);
  if (!content) {
    return { content, errorKey: "support.message_input.invalid" };
  }
  if (content.length > MAX_LENGTH) {
    return { content, errorKey: "support.message_input.too_long" };
  }
  return { content };
}
